import { Exit } from "slotworks/state-machine/data/exit";
abstract class Decision {

    /**
     * Called when this decision is queried.
     *
     * @return {Exit}
     */
    public evaluate(): Exit {
        return Exit.True;
    }
}

export default Decision;



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/state-machine/decisions/decision.ts